import styled from 'styled-components'

export const NodeBase = styled.div`
  border-radius: 8px;
  border: 1px solid var(--background-3);
  background: var(--background-2);
`
